<template>
  <div class="main">
    <h5>{{item[1]}}<br>
      <small class="text-muted">{{item[9]}}</small>
    </h5>
    <h6>{{item[4]}}</h6>
    <p class="text-justify" v-html="item[5]"></p>
    <img v-if="item[13]" v-bind:src="item[13]" class="card-img-top" alt="...">
    <span class="text-justify" v-html="item[6]"></span>
  </div>
</template>
<script>
export default {
  created () {
    this.$store.state.title = '詳細'
    this.$store.state.showBack = true
    this.item = JSON.parse(localStorage.getItem('itemDetails'))
  },
  destroyed () {
    this.$store.state.showBack = false
  },
  data() {
    return {
      item: []
    }
  },
  mounted() {
    const that = this
    that.item = JSON.parse(localStorage.getItem('itemDetails'))
  }
}
</script>
<style scoped>
.main {
  padding: 12px;
  margin: 20px;
}
.nav {
  padding: 20px;
  font-size:10pt;
}
.nav .nav-item {
  color:#fb6e14;
}
.nav .nav-item-none {
  color:#d2d2d2;
}
.nav a {
  font-weight: bold;
  color: #fb6e14;
}

.nav a.router-link-exact-active {
  color: #fb6e14;
}
</style>
